import { WorkflowAdditionalOptionsSubBaseService } from "app/core/workflow/workflow-steps/applicant/sub/workflow-additional-options-sub-base.service";

export class WorkflowAdditionalOptionsTwoService extends WorkflowAdditionalOptionsSubBaseService {
  public get subStepNumber(): number {
    return 3;
  }
}
